import React, { useMemo } from 'react'
import { CircleLayer, Layer, Source } from 'react-map-gl'
import { IPoint } from 'utils/interfaces'

const cleaningRouteFinishPointStyle1: CircleLayer = {
  id: 'mission-finish-point1',
  type: 'circle',
  paint: {
    'circle-radius': 8,
    'circle-color': '#9747FF',
  },
}

const cleaningRouteFinishPointStyle2: CircleLayer = {
  id: 'mission-finish-point2',
  type: 'circle',
  paint: {
    'circle-radius': 7,
    'circle-color': 'white',
  },
}

const cleaningRouteFinishPointStyle3: CircleLayer = {
  id: 'mission-finish-point3',
  type: 'circle',
  paint: {
    'circle-radius': 5,
    'circle-color': '#9747FF',
  },
}

// launch point
const cleaningRouteLaunchPointStyle1: CircleLayer = {
  id: 'mission-start-point',
  type: 'circle',
  paint: {
    'circle-radius': 8,
    'circle-color': 'rgba(151, 71, 255, 1)',
  },
}

const cleaningRouteLaunchPointStyle2: CircleLayer = {
  id: 'mission-start-point-center',
  type: 'circle',
  paint: {
    'circle-radius': 6,
    'circle-color': 'white',
  },
}

const MissionStartFinishPoints = ({
  startPoint,
  finishPoint,
  startPoints,
  finishPoints,
}: {
  startPoint?: IPoint
  finishPoint?: IPoint
  startPoints?: (IPoint | undefined)[]
  finishPoints?: (IPoint | undefined)[]
}) => {
  const allStartPoints = useMemo(() => {
    const pts = [...(startPoints || [])]
    if (startPoint) pts.push(startPoint)
    return pts.filter(Boolean) as IPoint[]
  }, [startPoint, startPoints])

  const allFinishPoints = useMemo(() => {
    const pts = [...(finishPoints || [])]
    if (finishPoint) pts.push(finishPoint)
    return pts.filter(Boolean) as IPoint[]
  }, [finishPoint, finishPoints])

  const startData = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: allStartPoints,
    }),
    [allStartPoints]
  )

  const finishData = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: allFinishPoints,
    }),
    [allFinishPoints]
  )

  return (
    <>
      {allStartPoints.length > 0 && (
        <Source id="mission-start-point" type="geojson" data={startData as any}>
          <Layer {...cleaningRouteLaunchPointStyle1} />
          <Layer {...cleaningRouteLaunchPointStyle2} />
        </Source>
      )}
      {allFinishPoints.length > 0 && (
        <Source id="mission-finish-point" type="geojson" data={finishData as any}>
          <Layer {...cleaningRouteFinishPointStyle1} />
          <Layer {...cleaningRouteFinishPointStyle2} />
          <Layer {...cleaningRouteFinishPointStyle3} />
        </Source>
      )}
    </>
  )
}

export default MissionStartFinishPoints
